module.exports = __webpack_public_path__ + "img/home-button.80dc8a97.png";